import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {computed, onMounted, PropType, ref, watchEffect} from "vue";
import {AppConfigComponentListStyle} from "@/model/AppConfig";
import {Resource} from "@/model/Resource";
import AppConfigComponentDrawerResourceVerticalCom
  from "@/views/appconfig/drawer/AppConfigComponentDrawerResourceVerticalCom.vue";
import AppConfigComponentDrawerResourceHorizontalCom
  from "@/views/appconfig/drawer/AppConfigComponentDrawerResourceHorizontalCom.vue";


const __default__ = {
  name: "AppConfigComponentDrawerResourceHorizontalCom"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  resource: {
    type: Object as PropType<Resource>,
    required: true
  },
  listStyle: {
    type: Number as PropType<AppConfigComponentListStyle>,
    required: true
  }
},
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.listStyle === _unref(AppConfigComponentListStyle).VERTICAL)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerResourceVerticalCom, {
          key: 0,
          resource: __props.resource,
          "list-style": __props.listStyle
        }, null, 8, ["resource", "list-style"]))
      : _createCommentVNode("", true),
    (__props.listStyle === _unref(AppConfigComponentListStyle).HORIZONTAL)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerResourceHorizontalCom, {
          key: 1,
          resource: __props.resource,
          "list-style": __props.listStyle
        }, null, 8, ["resource", "list-style"]))
      : _createCommentVNode("", true)
  ]))
}
}

})